// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"52c02991","140":"5084c9b8","390":"c95d1c62","416":"c623078d","599":"ba9d2661","679":"5d1b6ace","822":"fbb8aa34"}[chunkId] + ".chunk.js";
};